<p-panel *ngIf="progressor != null" class="overlay" header="Fortschritt">
    <p-progressBar [value]="_Utils.toNumber(_Utils.restrictDecimalDigits(_Utils.divSafe(progressor.value * 100, progressor.max), 0))"></p-progressBar>
    <div *ngIf="showCalculated"><b>{{_Utils.restrictDecimalDigits(progressor.value, 0)}} / {{_Utils.restrictDecimalDigits(progressor.max, 0)}}</b></div>
    <div>{{progressor.text}}</div>
</p-panel>
